import {times} from './function';

const
    number = (low, high) => {
        let temp;

        if (low > high) {
            temp = low;
            low = high;
            high = temp;
        }
        return low + (Math.random() * (high - low));
    },

    integer = (low, high) => (
        Math.floor(
            number(low, high))),

    string = (
        length,
        alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz') => {

        const
            characters = [],
            alphalength = alphabet.length;

        times(length, () => {
            characters.push(alphabet[integer(0, alphalength)]);
        });
        return characters.join('');
    },

    sample = (array, size) => {
        const
            output = array.slice(),
            length = output.length;
        let choice,
            value;

        if (size > length) {
            size = length;
        }
        for (let i = 0; i < size; i += 1) {
            choice = integer(i, length);
            value = output[choice];
            output[choice] = output[i];
            output[i] = value;
        }
        return output;
    },

    shuffle = array => (
        sample(
            array,
            array.length)),

    // Adapted from https://gist.github.com/jed/982883.
    uuid = () => {
        return (
            `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`
            .replace(
                /[018]/g,
                value => {
                    value = parseInt(value, 10);
                    return (value ^ ((Math.random() * 16) >> (value >> 2))).toString(16);
                }));
    };

export {
    number,
    integer,
    string,
    sample,
    shuffle,
    uuid
};
